import SignInPageView from "./SignInPageView";

function SignInPage() {
  return <SignInPageView />;
}

export default SignInPage;
